import { IonIcon } from "@ionic/react";
import PubSub from "../../lib/PubSub";
import React from "react";

import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import { closeCircle, closeCircleOutline, searchOutline } from "ionicons/icons";

export const geocodeResult = (address: any) => {
  let result: any = null;

  return new Promise((resolve, reject) => {
    geocodeByAddress(address)
      .then((results: any) => {
        result = results[0];

        getLatLng(result);
      })
      .then((latLng: any) => {
        console.log("Success", latLng);

        resolve({ result, geographic: latLng });
      })
      .catch((error: any) => reject(error));
  });
};

export default class LocationSearchInputV2 extends React.Component<any> {
  state: any = {
    address: "",
  };

  componentDidMount(): void {
    PubSub.subscribe("locationSearchClear", () => {
      this.setState({ address: "" });
    });
  }

  handleChange = (address: any) => {
    this.setState({ address });

    if (typeof this.props.onChange == "function") {
      this.props.onChange({ address });
    }
  };

  handleSelect = (address: any) => {
    let result: any = null;

    geocodeByAddress(address)
      .then((results: any) => {
        result = results[0];

        return getLatLng(result);
      })
      .then((latLng: any) => {
        console.log("Success", latLng);

        if (typeof this.props.onSelect == "function") {
          this.props.onSelect({ result, geographic: latLng });
        }
      })
      .catch((error: any) => console.error("Error", error));
  };

  render() {
    return (
      <>
        {typeof window?.google?.maps?.places?.Autocomplete == "function" &&
        window?.google?.maps?.places?.Autocomplete ? (
          <PlacesAutocomplete
            value={this.state.address}
            onChange={this.handleChange}
            onSelect={this.handleSelect}
          >
            {({
              getInputProps,
              suggestions,
              getSuggestionItemProps,
              loading,
            }: any) => (
              <div className="relative">
                <div className="absolute left-2.5 top-3 sm:top-3.5 sm:left-3 text-lg h-[2rem] w-[2rem]">
                  <IonIcon icon={searchOutline} className="text-gray-400" />
                </div>
                <input
                  type="text"
                  autoComplete="postal-code"
                  name="location"
                  id="location"
                  className={`block w-full text-base sm:text-md pr-3 pl-[2.25rem] rounded-tr rounded-tl border-0 py-2.5 sm:py-3 text-gray-900 shadow-sm outline-0 border-[1px] border-gray-100 placeholder:text-gray-400 transition-all focus:border-orange-500 sm:leading-6 ${
                    !loading && !suggestions?.length
                      ? "rounded-br rounded-bl"
                      : ""
                  }`}
                  placeholder={
                    this.props.placeholder
                      ? this.props.placeholder
                      : "Search Nearby"
                  }
                  {...getInputProps({
                    placeholder: this.props.placeholder
                      ? this.props.placeholder
                      : "Search Nearby",
                  })}
                />
                {getInputProps().value.length > 0 && (
                  <div className="absolute right-2.5 top-3 sm:top-3.5 sm:right-3 text-2xl h-[2rem] w-[1.5rem]">
                    <IonIcon
                      icon={closeCircleOutline}
                      className="text-gray-900"
                    />
                  </div>
                )}
                <div
                  className={`absolute w-[86vw] shadow-lg w-full -mt-5 sm:-mt-4 ${
                    loading || suggestions?.length
                      ? "rounded-br-lg rounded-bl-lg border border-gray-100 bg-white shadow top-[66px] z-[999] max-h-[15rem] overflow-y-auto"
                      : ""
                  }`}
                >
                  {loading && (
                    <div className="p-[0.75rem] text-base md:text-lg font-normal">
                      Searching...
                    </div>
                  )}
                  {!loading &&
                    suggestions.map((suggestion: any, i: any) => {
                      // inline style for demonstration purpose
                      const style = suggestion.active
                        ? { backgroundColor: "#fafafa", cursor: "pointer" }
                        : { backgroundColor: "#ffffff", cursor: "pointer" };
                      return (
                        <div
                          key={i}
                          {...getSuggestionItemProps(suggestion, {
                            className:
                              "p-[0.75rem] text-base md:text-lg font-normal",
                            style,
                          })}
                        >
                          <span>{suggestion.description}</span>
                        </div>
                      );
                    })}
                </div>
              </div>
            )}
          </PlacesAutocomplete>
        ) : (
          <div className="relative">
            <label
              htmlFor="name"
              className="absolute rounded -top-[9px] sm:-top-[12px] left-2 inline-block bg-white px-1.5 text-sm sm:text-base font-medium text-gray-400"
            >
              Enter Your Location
            </label>
            <div className="px-3 bg-gray-25 sm:px-4 text-gray-500 block w-full text-base sm:text-xl rounded border-0 py-3 sm:py-4 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 transition-all focus:ring-2 focus:ring-inset focus:ring-orange-500 sm:leading-6">
              Loading...
            </div>
          </div>
        )}
      </>
    );
  }
}
